import { render, staticRenderFns } from "./RecurringRemarkSideMenu.vue?vue&type=template&id=09d42326"
import script from "./RecurringRemarkSideMenu.vue?vue&type=script&lang=js"
export * from "./RecurringRemarkSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports